// src/i18n/en/adminOptions.ts

/**
 * English translations for Admin Options feature
 */
const adminOptions = {
  name: 'Administration options',
  title: 'Administration options',

  // Section navigation
  nav: {
    label: 'Sections',
    current: 'Section:',
  },

  // Tab labels
  tabs: {
    devices: 'Devices',
    hotels: 'Properties',
    groups: 'Groups',
    users: 'Users',
    backups: 'Backups',
    notifications: 'Notifications',
    labels: 'Labels',
    system: 'System',
  },

  // Backups tab (mounts the shared backup panel)
  backups: {
    title: 'Backups',
    description: 'Scheduled copies of the application data, with restore and export.',
  },

  // Metadata popover
  metadata: {
    title: 'Device Metadata',
    copyJson: 'Copy as JSON',
    copied: 'Metadata copied to clipboard',
    empty: 'No metadata available',
  },

  // Help
  help: {
    page: 'Manage devices, properties, and groups from a single consolidated view. Use the toggle buttons to switch between different admin sections.',
  },

  // Event Notifications
  eventNotifications: {
    title: 'Event Notifications',
    subtitle: 'Configure email notifications for your device events.',
    selectHotel: 'Select a property',
    selectHotelHelper: 'Choose the property you want to configure notifications for.',
    noHotels: 'No properties available.',
    enabled: 'Enable event notifications',
    recipients: {
      title: 'Recipients',
      add: 'Add',
      placeholder: 'Enter an email address',
      empty: 'No recipients configured.',
      invalidEmail: 'Invalid email address.',
      duplicateEmail: 'This email is already in the list.',
    },
    preferences: {
      title: 'Events to notify',
      dispenser: 'Dispenser',
      kiosk: 'Kiosk',
      online: 'Online / Mobile',
      general: 'General',
      notifyKeyDispensed: 'Key dispensed',
      notifyKeyDispensedHelper: 'One email per key dispensed (may generate many emails).',
      notifyCardLow: 'Low cards',
      notifyCardLowHelper: 'Alert when the dispenser is running low on cards.',
      notifyCardEmpty: 'No cards',
      notifyCardEmptyHelper: 'Urgent alert when the dispenser has run out of cards.',
      notifyCheckInCompleted: 'Check-in completed',
      notifyCheckInCompletedHelper: 'Alert for check-in completed at kiosk.',
      notifyPreCheckInCompleted: 'Pre check-in completed',
      notifyPreCheckInCompletedHelper: 'Alert for pre check-in completed online or from mobile.',
      notifyCriticalErrors: 'Critical errors',
      notifyCriticalErrorsHelper: 'Alert for errors with critical severity.',
    },
    actions: {
      save: 'Save configuration',
      sendTest: 'Send test',
      applyToGroup: 'Apply to all properties in group',
    },
    messages: {
      saveSuccess: 'Notification configuration saved successfully.',
      saveError: 'Error saving notification configuration.',
      testSuccess: 'Test email sent successfully.',
      testError: 'Error sending test email.',
      applySuccess: 'Configuration applied to all properties in the group.',
      applyError: 'Error applying configuration to group.',
      applyConfirm: 'This will copy the notification configuration from this property to all other properties in the group. Do you want to continue?',
      disableSuccess: 'Notifications disabled successfully.',
      unsavedChanges: 'You have unsaved changes. Do you want to discard them?',
      noConfig: 'This property has no event notifications configured. Enable notifications to get started.',
    },
  },
};

export default adminOptions;
